var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTgChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#2AABEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.306 18.888C15.4072 16.6302 18.808 15.1416 20.5084 14.4224C25.3691 12.3689 26.3779 12.0122 27.0367 12.0001C27.1816 11.9977 27.5042 12.0341 27.7147 12.207C27.8896 12.3529 27.9388 12.5501 27.9634 12.6886C27.9853 12.8269 28.0154 13.1422 27.9908 13.3883C27.7283 16.1994 26.5884 23.021 26.0088 26.1696C25.7655 27.5018 25.2816 27.9485 24.8141 27.9921C23.7972 28.0871 23.0262 27.3099 22.0421 26.6546C20.503 25.6288 19.6336 24.9904 18.1382 23.9896C16.4105 22.8329 17.5313 22.1971 18.5155 21.1582C18.7725 20.8863 23.2504 16.7488 23.3352 16.3735C23.3461 16.3266 23.357 16.1516 23.2531 16.0594C23.152 15.9669 23.0016 15.9985 22.8923 16.0235C22.7365 16.0591 20.2788 17.7113 15.5111 20.9799C14.814 21.4671 14.1825 21.7046 13.6138 21.6921C12.9905 21.6785 11.7877 21.3332 10.8937 21.0382C9.80021 20.6763 8.92814 20.4849 9.00468 19.8702C9.04295 19.5502 9.47763 19.2227 10.306 18.888Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgChannel);
export default __webpack_public_path__ + "static/media/TG-channel.c31d4254241135635010ab6758d70828.svg";
export { ForwardRef as ReactComponent };